import axiosInstance from '../utils/axiosInstance';

interface HostedPageResponse {
  id: string;
  type: string;
  url: string;
  state: string;
  embed: boolean;
  created_at: number;
  expires_at: number;
}

interface UpdateSubscriptionResponse {
  success: boolean;
  hosted_url_data?: {
    hosted_page: HostedPageResponse;
  };
}
interface Invoice {
  invoice_id: string;
  billing_date: string;
  plan: string;
  amount: number;
  status: string;
  currency: string;
  due_date: string;
  paid_at?: string;
}

interface GetInvoicesResponse {
  success: boolean;
  data?: Invoice[];
  error?: string;
}

interface DownloadInvoiceResponse {
  success: boolean;
  data?: {
    download_url: string;
  };
  error?: string;
}

interface CancelSubscriptionResponse {
  success: boolean;
  error?: string;
}
interface PaymentMethodUpdateResponse {
  success: boolean;
  error?: string;
}
interface SubscriptionStatusResponse {
  planId: string;
  status: string;
}

class BillingService {

  async updateSubscription(planId: string, currentPageUrl: string, planName?: string, subscriptionId?: string, userId?: string): Promise<UpdateSubscriptionResponse> {
    try {
      const response = await axiosInstance.post('/billing/updateSubscription', {
        plan_id: planId,
        current_page_url: currentPageUrl,
        embed: true,
        planName: planName,
        subscriptionId: subscriptionId,
        userId: userId
      });
      
      return {
        success: true,
        hosted_url_data: response.data.hosted_url_data
      };
    } catch (error) {
      console.log('Subscription update error:', error);
      return {
        success: false
      };
    }
  }
 
  async getInvoices(): Promise<GetInvoicesResponse> {
    try {
      const response = await axiosInstance.get('/billing/listUserInvoices');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error: any) {
      //if it is 401 then redirect to login
      if (error.response && error.response.status === 401) {
        window.location.href = '/login';
      }
      console.log('Failed to fetch invoices:', error);
      return {
        success: false,
        error: 'Could not fetch invoices'
      };
    }
  }


  async downloadInvoice(invoiceId: string): Promise<DownloadInvoiceResponse> {
    try {
      const response = await axiosInstance.get(`/billing/invoices/${invoiceId}/download`);
      return {
        success: true,
        data: {
          download_url: response.data.data.download_url
        }
      };
    } catch (error) {
      return {
        success: false,
        error: 'Could not download invoice'
      };
    }
  }
  async cancelSubscription(reason: string): Promise<CancelSubscriptionResponse> {
    try {
      const response = await axiosInstance.post('/billing/cancelSubscription', {
        reason: reason
      });
      
      return {
        success: true
      };
    } catch (error) {
      console.log('Failed to cancel subscription:', error);
      return {
        success: false,
        error: 'Failed to cancel subscription'
      };
    }
  }

  async updatePaymentMethod(token: string): Promise<PaymentMethodUpdateResponse> {
    try {
      const response = await axiosInstance.post('/billing/updatePaymentMethod', {
        payment_token: token
      });
      
      return {
        success: true
      };
    } catch (error: any) {
      console.error('Payment update error:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to update payment method'
      };
    }
  }
 
  async getSubscriptionStatus(): Promise<SubscriptionStatusResponse> {
    try {
      const response = await axiosInstance.get('/billing/subscriptionStatus');
      return response.data; 
    } catch (error) {
      console.log('Get subscription status error:', error);
      throw error;
    }
  }
  // async getPaymentMethod(): Promise<any> {
  //   try {
  //     const response = await axiosInstance.get('/billing/getPaymentMethod');
  //     return {
  //       success: true,
  //       data: response.data.data
  //     };
  //   } catch (error) {
  //     console.error('Failed to fetch payment method:', error);
  //     return {
  //       success: false,
  //       error: 'Could not fetch payment method'
  //     };
  //   }
  // }



  
  


}
export default BillingService;
